import React from 'react';

export const ImageModeContext = React.createContext({
	articles: [],
    article: null,
    onArticleChange: () => {}
});
